// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiGrid-root.studioMainContainer {
    display: flex;
    width: 100%;
    gap: 16px;
    justify-content: space-between; 
    align-items: center;
}

.MuiGrid-root.studioNavContainer {
    background-color: #4C40AB;
    height: 45px;
    display: flex;
    justify-content: center; 
    align-items: center; 
    padding: 0px 20px; 
    width: 100%;
}
.MuiTypography-root.studioNavHeading{
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 20px;
    color: #EBEBF5;
    padding-left: 20px;
    padding-top: 20px;
    /* height: 30px; */
}

.studioNav {
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
}

.studioLogo {
    width: 22px;
    height: 18px;
    color: #FFFFFF;
}

.MuiTypography-root.studioText {
    font-family: var(--font-family-primary);
    font-size: 14px;
    font-weight: 400;
    line-height: 26.6px;
    color: #FFFFFF;
}

@media screen and (min-width: 768px) {
    .MuiGrid-root.studioNavContainer {
        width: auto;
    }
}
@media screen and (max-width: 460px) {
.mainContainer{
    padding: 0%;
}
}`, "",{"version":3,"sources":["webpack://./src/components/Header/StudioNav.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;AACA;AACA;IACI,WAAW;AACf;AACA","sourcesContent":[".MuiGrid-root.studioMainContainer {\n    display: flex;\n    width: 100%;\n    gap: 16px;\n    justify-content: space-between; \n    align-items: center;\n}\n\n.MuiGrid-root.studioNavContainer {\n    background-color: #4C40AB;\n    height: 45px;\n    display: flex;\n    justify-content: center; \n    align-items: center; \n    padding: 0px 20px; \n    width: 100%;\n}\n.MuiTypography-root.studioNavHeading{\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 20px;\n    color: #EBEBF5;\n    padding-left: 20px;\n    padding-top: 20px;\n    /* height: 30px; */\n}\n\n.studioNav {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    align-items: center;\n}\n\n.studioLogo {\n    width: 22px;\n    height: 18px;\n    color: #FFFFFF;\n}\n\n.MuiTypography-root.studioText {\n    font-family: var(--font-family-primary);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 26.6px;\n    color: #FFFFFF;\n}\n\n@media screen and (min-width: 768px) {\n    .MuiGrid-root.studioNavContainer {\n        width: auto;\n    }\n}\n@media screen and (max-width: 460px) {\n.mainContainer{\n    padding: 0%;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
